import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { CreateGebiedLabelButton } from '../../../label/components/CreateGebiedLabelButton'
import { GebiedLabels } from '../../../label/components/GebiedLabels'
import { StyledError } from '../../../theme/components/StyledError'
import { useHoofdleidingValuelists } from '../../../valuelists/hooks/useHoofdleidingValuelists'
import { useLabelsSearch } from '../hooks/useLabelsSearch'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { ContractinstellingenLabels }

type Props = {
  filters: ContractinstellingenSearchFilters
}

const ContractinstellingenLabels = ({ filters }: Props) => {
  const user = useAuthenticatedUser()
  const {
    data: { gebieden },
  } = useHoofdleidingValuelists()
  const {
    data: { items: labels },
    isLoading,
    error,
  } = useLabelsSearch({ externalFilters: filters })

  const { verantwoordelijke } = filters

  return (
    <>
      <StyledError error={error} />

      {isLoading && (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {verantwoordelijke && (
        <CreateGebiedLabelButton
          user={user}
          projectType="Hoofdleiding"
          verantwoordelijke={verantwoordelijke.code}
          gebieden={gebieden}
        />
      )}

      <GebiedLabels user={user} labels={labels} />

      {!isLoading && labels.length === 0 && (
        <Typography>Selecteer filters om te zoeken.</Typography>
      )}
    </>
  )
}
